import React, { FC, useMemo } from "react";
import { GetTransactionsResponseDto } from "../../../common/dto/transactions/getTransactions/get-transactions-response.dto";
import { Loader } from "../../general/Loader";
import { ActionCardSection } from "../ActionCardSection";
import { TransactionListItemDto } from "../../../common/types/transaction";
import { TransactionsPreviewTable } from "./TransactionsPreviewTable";

interface Props {
    data?: GetTransactionsResponseDto;
    isLoading: boolean;
    inOpened: boolean;
    sectionTitle(transactionsCount: number): React.ReactNode;
    onViewAll(): void;
    className?: string;
    children?(transactions: TransactionListItemDto[]): React.ReactNode;
}

export const TransactionsSection: FC<Props> = ({
    data,
    onViewAll,
    sectionTitle,
    inOpened,
    isLoading,
    className,
    children,
}) => {
    const total = data?.total ?? 0;
    const transactions = useMemo(() => data?.data ?? [], [data?.data]);

    let sectionContent: React.ReactNode;

    if (isLoading) {
        sectionContent = (
            <div className={className}>
                <Loader inline /> Loading...
            </div>
        );
    } else if (total > 0) {
        sectionContent = (
            <div className={className}>
                <TransactionsPreviewTable
                    total={total}
                    transactions={transactions}
                    onViewAll={onViewAll}
                />
            </div>
        );
    } else {
        sectionContent = null;
    }

    return (
        <>
            <ActionCardSection header={sectionTitle(total)} inOpened={inOpened}>
                {sectionContent}
            </ActionCardSection>

            {children?.(transactions)}
        </>
    );
};
